module.exports = __webpack_public_path__ + "images/help/avatars/ruochen-0b6028fd247173b7be95ec363708e246.jpg";